import { fm } from 'Components/FormatMessage';
import { Item } from 'Components/Grid';
import HistoryRow from 'Components/HistoryRow';
import HistoryRowControls from 'Components/HistoryRowControls';
import HistoryRowListing from 'Components/HistoryRowListing';
import * as React from 'react';
import { formatPartialDate } from 'Utility/date';
import { filterDocumentsByType } from 'Utility/documentHandling';
import { newButton } from '../../../../utils/functions';

import type { IHistoryContext } from 'Containers/FormContextHandler';

const DEFAULT_DOCUMENTS: IDocumentWithTypeV2<'syndrome'>[] = [];
const SyndromeHistory = ({
  documents = DEFAULT_DOCUMENTS,
  startEdit,
}: IHistoryContext<IDocumentWithTypeV2<'syndrome'>>): React.JSX.Element => {
  return (
    <HistoryRow
      headerText={fm('diagnosis.epilepsy.syndrome.title')}
      rowButton={startEdit ? newButton('syndrome', startEdit({}, 'syndrome'), 'general.new', 15) : undefined}
    >
      <HistoryRowListing
        documents={filterDocumentsByType(documents, ['syndrome'])}
        headers={
          <>
            <Item xs={4}>{fm('diagnosis.epilepsy.syndrome.title')}</Item>

            <Item xs={6}>{fm('diagnosis.epilepsy.orphaCode')}</Item>

            <Item xs={2}>{fm('diagnosis.epilepsy.diagnosisDate')}</Item>
          </>
        }
        contentFormat={d => (
          <>
            <Item xs={4}>
              <div>
                {d.syndrome ? fm(`diagnosis.epilepsy.syndrome.opts.${d.syndrome}`) : '-'}
                {d.syndrome === 'otherKnownSyndrome' ? ':' : ''}
              </div>
              <div>{d.syndrome === 'otherKnownSyndrome' ? d.syndromeSpecification : ''}</div>
            </Item>
            <Item xs={6}>{d.orphaCode ?? '-'}</Item>
            <Item xs={2}>{formatPartialDate(d.date)}</Item>
          </>
        )}
        collapse={true}
        makeControls
        historyRowControls={d => (startEdit ? <HistoryRowControls document={d} startEdit={startEdit} /> : <></>)}
      />
    </HistoryRow>
  );
};

export default SyndromeHistory;
